<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-map-marker mr-2" />Lokasi</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter.name"
                            type="search"
                            id="filterInput"
                            placeholder="Nama"
                            @keyup.enter="getItems"
                        />
                        <b-form-select v-model="filter.tipe" :options="optTipe" class="mr-2">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Tipe Lokasi</b-form-select-option>
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                            </template>
                        </b-form-select>
                        <multiselect v-model="filter.wilayah"
                            class="mr-2"
                            :options="optWilayah"
                            :allow-empty="true"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Wilayah"
                        />
                        <b-form-select v-model="filter.status" :options="optStatus" class="mr-2">
                            <template v-slot:first>
                                <b-form-select-option :value="-2" disabled>Status</b-form-select-option>
                                <b-form-select-option :value="-1">Semua</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search" />
                        </b-button>
                    </div>
                </b-form-group>
            </div>
            <div>
                <b-button class="mb-3 mr-2" variant="success" @click="openDownloadModal">
                    <i class="fa fa-download mr-2" />Download Excel
                </b-button>
                <b-button v-if="isAddEditAllowed" class="mb-3" variant="primary" @click="$bvModal.show('modal-input')">Input Lokasi Baru</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada lokasi.
                </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.name }}
                    <div v-if="statusWithDateAndNotes.includes(row.item.status.id)" class="text-muted small">
                        Tanggal: {{ $helper.parseDate(row.item.dhpDate) }}<br />
                        {{ row.item.notes }}
                    </div>
                </template>
                <template v-slot:cell(wilayah)="row">
                    {{ row.item.wilayah.name }}
                </template>
                <template v-slot:cell(tipe)="row">
                    <b-badge :variant="parseBadgeVariantTipe(row.item.tipe.id)">
                        {{ row.item.tipe.name }}
                    </b-badge>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge v-if="row.item.status.id == 0" variant="danger">TUTUP</b-badge>
                    <b-badge v-else-if="row.item.status.id == 1" variant="success">BUKA</b-badge>
                    <b-badge v-else-if="row.item.status.id == 2" variant="dark">DHP</b-badge>
                    <b-badge v-else-if="row.item.status.id == 3" variant="warning">LAINNYA</b-badge>
                    <b-badge v-else variant="light">-</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button v-if="isAddEditAllowed" size="sm" variant="primary" v-b-tooltip.hover.top title="Edit" @click="openEditModal(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>
                    <b-button v-if="row.item.tipe.id == 1" class="ml-2" size="sm" variant="dark" v-b-tooltip.hover.top title="Engine & Unit" @click="openInvenModel(row.item)">
                        <i class="fa fa-fw fa-cubes" />
                    </b-button>
                    <b-button size="sm" variant="success" class="ml-2" v-b-tooltip.hover.top title="Log Perpindahan Barang" @click="openMovementLogModal(row.item)">
                        <i class="fa fa-fw fa-truck" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <b-modal id="modal-invens" :title="'Inventaris Sumur ' + activeItem.name" centered no-close-on-backdrop hide-footer>
            <div v-if="isGettingInvens == true">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <strong>Engines</strong>
                <ul v-if="invens.engines.length != 0">
                    <li v-for="item in invens.engines" v-bind:key="item.sn">
                        {{ item.sn }}, {{ item.tipe }}
                    </li>
                </ul>
                <div v-else>Tidak ada engine</div>
                <div class="mt-4">
                    <strong>Elit / ESP</strong>
                    <ul v-if="invens.units.length != 0">
                        <li v-for="item in invens.units" v-bind:key="item.sn">
                            {{ item.category }} - {{ item.sn }}, {{ item.tipe }}<span v-if="item.additionalSpecs != null"> ({{ item.additionalSpecs }})</span>
                        </li>
                    </ul>
                    <div v-else>Tidak ada unit</div>
                </div>
            </div>
            <div v-if="isAddEditAllowed && (invens.engines.length != 0 || invens.units.length != 0)">
                <div class="text-right">
                    <b-button variant="danger" @click="$bvModal.show('modal-confirm-cabut-habis')">
                        Cabut Habis
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="modal-input" title="Input Lokasi Baru"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.inputName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="inputName" v-model="input.name" @keyup.enter="executeInput" />
            </b-form-group>
            <b-form-group label="Tipe Lokasi">
                <b-form-select v-model="input.tipe" :options="optTipe" />
            </b-form-group>
            <b-form-group label="Wilayah">
                <multiselect
                    v-model="input.wilayah"
                    :options="optWilayah"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih Wilayah"
                />
            </b-form-group>
            <b-form-group label="Status">
                <b-form-select v-model="input.status" :options="optStatus" />
            </b-form-group>
            <div v-if="statusWithDateAndNotes.includes(input.status)">
                <b-form-group label="Tanggal">
                    <b-form-input type="date" v-model="input.tanggal" />
                </b-form-group>
                <b-form-group label="Catatan">
                    <b-form-input v-model="input.catatan" maxlength="255" />
                    <div class="text-right small text-muted">{{ input.catatan.length }} / 255</div>
                </b-form-group>
            </div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-edit" title="Edit Lokasi"
            centered no-close-on-backdrop hide-footer
            @shown="$refs.editName.focus()"
        >
            <b-form-group label="Nama">
                <b-form-input ref="editName" v-model="edit.name" @keyup.enter="executeEdit" />
            </b-form-group>
            <b-form-group label="Tipe Lokasi">
                <b-form-select v-model="edit.tipe" :options="optTipe" />
            </b-form-group>
            <b-form-group label="Wilayah">
                <multiselect
                    v-model="edit.wilayah"
                    :options="optWilayah"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih Wilayah"
                />
            </b-form-group>
            <b-form-group label="Status">
                <b-form-select v-model="edit.status" :options="optStatus" />
            </b-form-group>
            <div v-if="statusWithDateAndNotes.includes(edit.status)">
                <b-form-group label="Tanggal">
                    <b-form-input type="date" v-model="edit.tanggal" />
                </b-form-group>
                <b-form-group label="Catatan">
                    <b-form-input v-model="edit.catatan" maxlength="255" />
                    <div class="text-right small text-muted">{{ edit.catatan.length }} / 255</div>
                </b-form-group>
            </div>
            <div class="text-right">
                <b-btn variant="primary" :disabled="isSubmitting" @click="executeEdit">
                    <b-spinner small type="grow" v-if="isSubmitting" />
                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                </b-btn>
            </div>
        </b-modal>
        <b-modal id="modal-confirm-cabut-habis" title="Konfirmasi Cabut Habis" centered no-close-on-backdrop hide-footer>
            Konfirmasi cabut habis sumur {{ activeItem.name }}?<br />
            Cabut Habis akan mengembalikan semua engine ke WORKSHOP TUJUAN dan semua unit elit / ESP ke WAREHOUSE TUJUAN. Status engine dan unit akan berubah menjadi RETUR.
            <b-form-group class="mt-2"  label="Catatan / Keterangan">
                <b-form-textarea v-model="catatanCabutHabis" maxlength="1000" rows="3" max-rows="8" />
                <div class="text-right">
                    {{ catatanCabutHabis.length }} / 1000
                </div>
            </b-form-group>
            <b-form-group label="Workshop Tujuan (Engine)">
                <multiselect v-model="workshopCabutHabis"
                    :options="optWorkshop"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih workshop"
                />
            </b-form-group>
            <b-form-group label="Warehouse Tujuan (Elit & ESP)">
                <multiselect v-model="warehouseCabutHabis"
                    :options="optWarehouse"
                    :internal-search="true"
                    deselect-label=""
                    select-label=""
                    label="name"
                    track-by="id"
                    placeholder="Pilih warehouse"
                />
            </b-form-group>
            <b-form-group label="Tanggal Pengerjaan">
                <b-form-input type="date" v-model="tanggalCabutHabis" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="execCabutHabis">
                    {{ isSubmitting ? "Memproses..." : "Cabut Habis" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="modal-download-lokasi" title="Download Excel" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark" />
                <div class="mt-2">Mempersiapkan file, mohon menunggu...</div>
            </div>
            <div v-else-if="downloadStatus == 2">
                <div class="mb-2">File siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="downloadPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
        <b-modal id="modal-download-movement-log" title="Log Perpindahan Barang" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadMovementLogStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark" />
                <div class="mt-2">Mempersiapkan file, mohon menunggu...</div>
            </div>
            <div v-else-if="downloadMovementLogStatus == 2">
                <div class="mb-2">File siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="downloadMovementLogPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'lokasi',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            isGettingInvens: false,
            roleId: -1,
            show: 10,

            invens: {
                engines: [],
                units: []
            },

            catatanCabutHabis: "",
            tanggalCabutHabis: "",
            workshopCabutHabis: null,
            warehouseCabutHabis: null,

            downloadStatus: 0,
            downloadPath: "",

            downloadMovementLogStatus: 0,
            downloadMovementLogPath: "",

            input: {
                name: "",
                tipe: 0,
                wilayah: null,
                status: 0,
                tanggal: "",
                catatan: ""
            },

            edit: {
                name: "",
                tipe: 0,
                wilayah: null,
                status: 0,
                tanggal: "",
                catatan: ""
            },

            filter: {
                name: "",
                tipe: -1,
                wilayah: null,
                status: -1
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama" },
                { key: "wilayah", label: "Wilayah" },
                { key: "tipe", label: "Tipe Lokasi" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {},

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optWilayah: [],
            optWarehouse: [],
            optWorkshop: [],
            optTipe: [
                { value: 0, text: "Workshop" },
                { value: 1, text: "Sumur" },
                { value: 2, text: "Sinkron" },
                { value: 3, text: "Warehouse" },
                { value: 4, text: "External" }
            ],
            optStatus: [
                { value: 0, text: "Tutup" },
                { value: 1, text: "Buka" },
                { value: 2, text: "DHP" },
                { value: 3, text: "Lainnya" }
            ],

            statusWithDateAndNotes: [2, 3]

        }
    },
    computed: {

        isAddEditAllowed() {
            return [0, 1, 8].includes(this.roleId)
        }

    },
    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getWilayahOpt = this.$axios.get("wilayah/selection").then(res => {
                this.optWilayah = res.data
            })

            let getWarehouse = this.$axios.get("lokasi/selection-by-type/3").then(res => {
                this.optWarehouse = res.data
            })

            let getWorkshop = this.$axios.get("lokasi/selection-by-type/0").then(res => {
                this.optWorkshop = res.data
            })

            Promise.all([getItems, getWilayahOpt, getWarehouse, getWorkshop]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        buildFilterParam() {

            let param = []

            if(!this.$helper.isBlank(this.filter.name)) {
                param.push("filterName=" + this.filter.name)
            }

            if(this.filter.tipe != -1) {
                param.push("filterTipe=" + this.filter.tipe)
            }

            if(!this.$helper.isBlank(this.filter.wilayah)) {
                param.push("filterWilayah=" + this.filter.wilayah.id)
            }

            if(this.filter.status != -1) {
                param.push("filterStatus=" + this.filter.status)
            }

            if(param.length == 0) {
                return ""
            }

            return "&" + param.join("&")

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += this.buildFilterParam()

            // Execute
            return this.$axios.get("lokasi/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.wilayah)) {
                return this.$helper.toastError(this, "Wilayah tidak boleh kosong!")
            }

            if(this.statusWithDateAndNotes.includes(this.input.status) && this.$helper.isBlank(this.input.tanggal)) {
                return this.$helper.toastError(this, "Tanggal tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("name", this.input.name)
            payload.append("tipe", this.input.tipe)
            payload.append("wilayahId", this.input.wilayah.id)
            payload.append("status", this.input.status)

            if(this.statusWithDateAndNotes.includes(this.input.status)) {
                payload.append("dhpDate", this.input.tanggal)
                payload.append("notes", this.input.catatan)
            }

            this.isSubmitting = true
            this.$axios.post("lokasi/", payload).then(res => {

                this.totalRows++

                this.$bvModal.hide("modal-input")
                this.$helper.toastSuccess(this, "Lokasi baru berhasil ditambahkan!")
                this.input.name = ""
                this.input.tanggal = ""
                this.input.catatan = ""
                this.getItems()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        executeEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.statusWithDateAndNotes.includes(this.edit.status) && this.$helper.isBlank(this.edit.tanggal)) {
                return this.$helper.toastError(this, "Tanggal tidak boleh kosong!")
            }

            let payload = new FormData()
            payload.append("id", this.activeItem.id)
            payload.append("name", this.edit.name)
            payload.append("tipe", this.edit.tipe)
            payload.append("wilayahId", this.edit.wilayah.id)
            payload.append("status", this.edit.status)

            if(this.statusWithDateAndNotes.includes(this.edit.status)) {
                payload.append("dhpDate", this.edit.tanggal)
                payload.append("notes", this.edit.catatan)
            }

            this.isSubmitting = true
            this.$axios.post("lokasi/", payload).then(res => {

                this.$bvModal.hide("modal-edit")
                this.$helper.toastSuccess(this, "Lokasi berhasil diubah!")
                this.getItems()

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        execCabutHabis() {

            if(this.$helper.isBlank(this.catatanCabutHabis)) {
                return this.$helper.toastError(this, "Mohon mengisi catatan!")
            }

            if(this.$helper.isBlank(this.tanggalCabutHabis)) {
                return this.$helper.toastError(this, "Mohon mengisi tanggal pengerjaan!")
            }

            if(this.workshopCabutHabis == null) {
                return this.$helper.toastError(this, "Mohon memilih workshop tujuan!")
            }

            if(this.warehouseCabutHabis == null) {
                return this.$helper.toastError(this, "Mohon memilih warehouse tujuan!")
            }

            let payload = new FormData()
            payload.append("lokasiId", this.activeItem.id)
            payload.append("catatan", this.catatanCabutHabis)
            payload.append("tanggal", this.tanggalCabutHabis)
            payload.append("tujuanWorkshopId", this.workshopCabutHabis.id)
            payload.append("tujuanWarehouseId", this.warehouseCabutHabis.id)

            this.isSubmitting = true
            this.$axios.post("lokasi/cabut-habis", payload).then(res => {

                this.$helper.toastSuccess(this, "Berhasil melakukan cabut habis untuk sumur " + this.activeItem.name + "!")
                this.$bvModal.hide("modal-confirm-cabut-habis")
                this.$bvModal.hide("modal-invens")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        openEditModal(item) {

            this.activeItem = item
            this.edit.name = item.name
            this.edit.tipe = item.tipe.id
            this.edit.wilayah = item.wilayah
            this.edit.status = item.status.id
            this.edit.tanggal = item.dhpDate || ""
            this.edit.catatan = item.notes || ""
            this.$bvModal.show("modal-edit")

        },

        openInvenModel(item) {

            this.activeItem = item
            this.$bvModal.show("modal-invens")

            this.isGettingInvens = true
            this.$axios.get("lokasi/inventories/?lokasiId=" + item.id).then(res => {

                this.invens.engines = res.data.engines
                this.invens.units = res.data.invens

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isGettingInvens = false)

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        openDownloadModal() {

            this.downloadStatus = 1
            this.downloadPath = ""

            this.$bvModal.show("modal-download-lokasi")

            this.$axios.get("lokasi/excel?" + this.buildFilterParam().substring(1)).then(res => {

                this.downloadPath = this.$BASE_FILE_PATH + res.data
                this.downloadStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-download-lokasi")
            })

        },

        openMovementLogModal(item) {

            this.downloadMovementLogStatus = 1
            this.downloadMovementLogPath = ""

            this.$bvModal.show("modal-download-movement-log")

            this.$axios.get("lokasi/movement-log/excel/?lokasiId=" + item.id).then(res => {

                this.downloadMovementLogPath = this.$BASE_FILE_PATH + res.data
                this.downloadMovementLogStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-download-movement-log")
            })

        },

        parseBadgeVariantTipe(id) {
            switch(id) {
                case 0: return "dark"
                case 1: return "success"
                case 2: return "primary"
                case 3: return "light"
                case 4: return "warning"
                default: return "light"
            }
        }

    },

    created() {
        this.roleId = this.$helper.getRoleId()
        this.init()
    }

}
</script>
